import * as community from './types';

const getters = {
  [community.FETCH_HOT_LIST]: state => state.hotList,
  [community.FETCH_BOARD]: state => state.board,
  [community.FETCH_BOARD_LIST]: state => state.boardList,
  [community.FETCH_BOARD_CNT]: state => state.boardCnt,
  [community.FETCH_BOARD_REPLY_LIST_MINE]: state => state.boardReplyListMine,
  [community.FETCH_BOARD_REPLY_LIST]: state => state.boardReplyList,
  [community.FETCH_KNOWHOW]: state => state.knowhow,
  [community.FETCH_KNOWHOW_LIST]: state => state.knowhowList,
  [community.FETCH_KNOWHOW_CNT]: state => state.knowhowCnt,
  [community.FETCH_KNOWHOW_ANSWER_LIST]: state => state.knowhowAnswerList,
  [community.FETCH_KNOWHOW_ANSWER_DETAIL]: state => state.knowhowAnswerDetail,
  [community.FETCH_KNOWHOW_REPLY_LIST]: state => state.knowhowReplyList,
  [community.FETCH_KNOWHOW_REPLY_LIST_MINE]: state =>
    state.knowhowReplyListMine,
  [community.FETCH_HOT_POST_LIST]: state => state.hotPostList,
};

export default getters;
